module.exports = __webpack_public_path__ + "35d3c9609ae0fe49c531446095b523cc.jpg";